<h1 mat-dialog-title>Alterar crédito cliente</h1>
<!-- <mat-divider></mat-divider> -->
<div mat-dialog-content style="width: 500px;">

    <form [formGroup]="creditoForm">
        <div class="row">
            <div class="col-sm-4">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Limite de crédito</mat-label>
                    <input matInput formControlName="creditoCliente" currencyMask
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                </mat-form-field>
            </div>

            <div class="col-sm-4">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Alteração</mat-label>
                    <input matInput formControlName="creditoEditar" currencyMask (ngModelChange)="onChangeCredito($event)"
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                </mat-form-field>
            </div>

            <div class="col-sm-4">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Crédito final</mat-label>
                    <input matInput formControlName="creditoFinal" currencyMask
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" required>
                </mat-form-field>
            </div>
        </div>

        <mat-divider></mat-divider>

        <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
            <button mat-flat-button color="warn" (click)="onClickCancelar()">
                <mat-icon>clear</mat-icon> Cancelar
            </button>
            <button mat-flat-button color="primary" (click)="onClickEditar()">
                <mat-icon>check</mat-icon> Confirmar alteração
            </button>
        </section>
    </form>
</div>